import * as React from 'react';

function SvgGoToHome(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={54.82} height={54.82} {...props}>
      <path
        d="M45.241 23.852l-3.027-2.884v-9.854a1.7 1.7 0 00-1.679-1.721h-7.7a1.7 1.7 0 00-1.58 1.16l-3.016-2.872a2.428 2.428 0 00-3.381 0L7.866 23.841a2.616 2.616 0 00-.641 2.817 2.476 2.476 0 002.331 1.624h2.165v15.677a1.644 1.644 0 001.657 1.668h26.339a1.607 1.607 0 001.613-1.668V28.282h2.221a2.471 2.471 0 002.331-1.635 2.6 2.6 0 00-.641-2.795zm-7.225 2.762v15.589h-22.98V26.614a1.721 1.721 0 00-1.657-1.757h-1.713l14.882-14.119 5.159 4.916a1.606 1.606 0 001.127.453 1.573 1.573 0 00.674-.144 1.719 1.719 0 00.972-1.569v-1.58h4.419v8.9a1.711 1.711 0 00.519 1.237l2 1.9h-1.712a1.756 1.756 0 00-1.69 1.763z"
        fill="#7689b4"
      />
      <g fill="#7689b4">
        <path d="M28.923 25.488h3.911l2.74-3.568h-3.7z" />
        <path d="M23.864 30.105h7.082v1.989h-5.181a5.318 5.318 0 01-1.613-.232 4.027 4.027 0 01-1.282-.663 2.922 2.922 0 01-1.138-2.364 2.837 2.837 0 01.309-1.337 3.363 3.363 0 01.851-1.05 3.975 3.975 0 011.282-.7 4.95 4.95 0 011.591-.243h1.944l2.961-3.557h-4.905a10.828 10.828 0 00-3.292.475 7.71 7.71 0 00-2.607 1.37 6.557 6.557 0 00-1.723 2.132 5.947 5.947 0 00-.619 2.74 6.334 6.334 0 00.619 2.773 6.843 6.843 0 001.723 2.21 8.424 8.424 0 002.607 1.469 9.893 9.893 0 003.292.53h9.4v-8.562h-8.761z" />
      </g>
      <g>
        <path
          d="M46.788 8.032A27.41 27.41 0 000 27.41a27.423 27.423 0 0027.41 27.41A27.4 27.4 0 0046.788 8.032zM27.41 51.285A23.875 23.875 0 1151.285 27.41 23.9 23.9 0 0127.41 51.285z"
          fill="#7689b4"
        />
      </g>
    </svg>
  );
}

export default SvgGoToHome;
